import { createInlineStyleButton } from '@draft-js-plugins/buttons';
import { FormatBold } from '@mui/icons-material';

const BoldButton = createInlineStyleButton({
  style: 'BOLD',
  children: <FormatBold />,
});

export default BoldButton;
